import { Component } from 'react';

/* Catches render/runtime errors from a lazy 3D scene (chunk load failure, WebGL
   init failure, a throw inside the scene) so one bad scene can never leave a
   permanently blank section or take down the page. Logs clearly and shows a
   graceful fallback; remounting with a fresh `key` (SceneMount does this when
   the section is re-approached) retries it. */
export default class SceneErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(`[Scene:${this.props.label || 'scene'}] failed to load/render:`, error, info?.componentStack);
    this.props.onError?.(error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#5C6478', fontSize: 12, letterSpacing: '.04em' }}>
          Visualization unavailable
        </div>
      );
    }
    return this.props.children;
  }
}
